export const REASON_OPTIONS = [
  { value: "", label: "Not specified" },
  { value: "community_guidelines", label: "Community guidelines" },
  { value: "spam", label: "Spam or manipulation" },
  { value: "harassment", label: "Harassment" },
  { value: "copyright", label: "Copyright" },
  { value: "privacy", label: "Privacy violation" },
  { value: "child_safety", label: "Child safety / CSAE" },
  { value: "csae", label: "CSAE" },
  { value: "sexual_exploitation", label: "Sexual exploitation" },
  { value: "other", label: "Other" },
];

export const REPORT_ACTIONS = [
  "dismiss", "warn", "ban", "end_stream", "remove_post", "remove_replay",
  "remove_clip", "remove_file", "remove_and_ban",
].map((value) => ({ value, label: value.replaceAll("_", " ") }));

export const moderationFields = ({ includeAction = false } = {}) => [
  ...(includeAction ? [{ name: "action", label: "Resolution", type: "select", options: REPORT_ACTIONS, defaultValue: "dismiss" }] : []),
  { name: "reason", label: "Reason", type: "select", options: REASON_OPTIONS },
  { name: "legal_hold", label: "Preserve evidence under legal hold", type: "checkbox", defaultValue: false },
  ...(includeAction ? [{ name: "file_path", label: "File path", type: "text", placeholder: "auralive/…", requiredWhen: (values) => values.action === "remove_file" }] : []),
  { name: "note", label: "Internal note", placeholder: "Optional audit context" },
];

export const cleanModerationPayload = (values, extra = {}) => {
  const payload = { ...values, ...extra };
  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== "" && value !== undefined && value !== null));
};

export const inferReportRemoval = (report) => {
  const type = String(report?.target_type || report?.content_type || report?.resource_type || report?.target?.type || "").toLowerCase();
  if (type.includes("post") || report?.post_id) return { action: "remove_post", kind: "post" };
  if (type.includes("replay") || report?.replay_id) return { action: "remove_replay", kind: "replay" };
  if (type.includes("clip") || report?.clip_id) return { action: "remove_clip", kind: "clip" };
  if (type.includes("file") || report?.file_path || report?.path) return { action: "remove_file", kind: "file", file_path: report.file_path || report.path };
  return null;
};

export const takedownModeMessage = (data) => {
  const mode = data?.mode || data?.data?.mode;
  if (mode === "soft_legal_hold") return "Content hidden and evidence preserved under legal hold.";
  if (mode === "hard") return "Content permanently removed.";
  return data?.message || "Takedown completed.";
};